"use client";
import { r as e, t } from "./registration-BkPgmtZ2.js";
import { t as n } from "./tokens-DBlg30G8.js";
//#region src/openers/neonPack/tokens.ts
var r = n, i = t(() => import("./NeonPackOpener-CYfmt-7_.js"), r);
function a() {
	e("neon_pack", i);
}
//#endregion
export { a as n, r, i as t };

//# sourceMappingURL=neonPack-bmhqbOUW.js.map